import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GlobalVariable } from 'src/app/global';
import { BaseComponent } from 'src/app/models/base-component';
import { GeneralService } from '../../../base/services/general/general.service';
import { PersistenciaService } from '../../../base/services/persistencia/persistencia.service';
import { UsuarioService } from '../../../base/services/usuario/usuario.service';

@Component({
  selector: 'app-configuracion-aplicacion-clientes',
  templateUrl: './configuracion-aplicacion-clientes.component.html',
  styleUrls: ['./configuracion-aplicacion-clientes.component.css']
})
export class ConfiguracionAplicacionClientesComponent extends BaseComponent implements OnInit {

  @Input() configuracion_pagina:any;
  @Input() usuario:any;
  @Output() alTerminar:EventEmitter<any>  = new EventEmitter<any>();
  tipo_codigo:any={clases:[{}]};
  es_usuario_administrador:boolean=false;

  constructor(public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public modalService: NgbModal,
    public toastr: ToastrService,
    public usuarioService:UsuarioService) {
      super(persistenciaService,modalService,generalService,usuarioService);
     }

  ngOnInit(): void {
    this.obtenerTiposCodigo();
  }

  async obtenerTiposCodigo(){
    this.tipo_codigo=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_CLIENTE).toPromise();
    if(!this.tipo_codigo.clases || this.tipo_codigo.clases.length==0){
      this.tipo_codigo.clases=[{nombre:"COD",nombre_corto:"1",habilitado:true}];
      await this.generalService.actualizarTipo(this.tipo_codigo).toPromise();
      this.tipo_codigo=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_CLIENTE).toPromise();
    }
  }

  guardarConfiguracionVista(){
    this.generalService.actualizarTipo(this.tipo_codigo).toPromise();
		this.configuracion_pagina.updateObject();
		this.toastr.success("Configuracion actualizada satisfactoriamente!");
		this.alTerminar.emit();
	}

  cerrarComponente(){
    this.alTerminar.emit();
  }

}
